<template>
	<BaseCmsPage v-slot="{page}">
	<Body class="page-checkout-step1" />
		<WebshopCheckoutLayout class="guest-checkout">
			<template #header>
				<WebshopCheckoutHeader :step="1" />
			</template>

			<template #wcCol1>
				<BaseWebshopCheckout v-slot="{cart}">
					<div class="wc-step1-col1">
						<BaseCmsLabel class="step1-titles" code="guest_checkout" tag="h2" />
						<div class="wc-cnt" v-html="page?.content" v-interpolation />

						<div class="wc-col-cnt">
							<BaseWebshopGuestForm class="wc-guest-form ajax_siteform form-animated-label" v-slot="{loading, fields}">
								<BaseFormField v-for="item in fields" :key="item.name" :item="item" v-slot="{errorMessage, floatingLabel}">
									<p class="field" :class="['field-' + item.name, {'ffl-floated': floatingLabel}]">
										<BaseFormInput id="guest-email" />
										<BaseCmsLabel tag="label" for="guest-email" :code="item.name" />
										<span class="field_error error" v-show="errorMessage" v-html="errorMessage" />
									</p>
								</BaseFormField>
								<button type="submit" class="btn btn-primary btn-wc-guest g-recaptcha" :class="{'loading': loading}"><UiLoader v-if="loading" /><BaseCmsLabel code="continue_without_signup" tag="span" /></button>
							</BaseWebshopGuestForm>
						</div>
					</div>

					<WebshopCheckoutTracking v-if="cart?.parcels[0]?.items?.length" step="1" :cart="cart" />
				</BaseWebshopCheckout>

				<div class="wc-step1-col2">
					<BaseCmsLabel class="step1-titles" code="checkout_login" tag="h2" />
					<div class="wc-col-cnt">
						<AuthLoginForm mode="checkout" />
					</div>
				</div>
			</template>
		</WebshopCheckoutLayout>
	</BaseCmsPage>
</template>

<script setup>
</script>

<style lang="less" scoped>
	.wc-cnt{
		font-weight: 300; font-size: 18px; line-height: 24px;
		:deep(p){font-size: 18px; line-height: 24px; padding-bottom: 12px; font-weight: 300;}
	}
	.btn-wc-guest{
		width: 195px; min-width: 195px; color: white; margin-right: 0; margin-bottom: 0; margin-top: 5px;
		@media (max-width: @t){margin: 5px 0 0 0;}
		@media (max-width: @m){min-width: 100%;}
	}
	:deep(.step1-titles){
		font-size: 30px; line-height: 38px; padding-bottom: 8px; font-weight: 300; padding-top: 0;
		@media (max-width: @t){font-size: 26px; line-height: 32px; padding-bottom: 8px;}
		@media (max-width: @tp){font-size: 20px; line-height: 26px; padding-bottom: 10px; font-weight: normal;}
	}
</style>

<style lang="less">
	.page-checkout-step1{
		@media (max-width: @m){
			.wc-col2{display: none;}
			.wc-footer{border: 1px solid var(--borderColor); margin-top: 30px;}
		}
		.wc-guest-form{
			padding-bottom: 50px; display: block !important;
			@media (max-width: @t){padding-bottom: 40px;}
			@media (max-width: @tp){padding-bottom: 30px;}
		}
	}
</style>
